export default __webpack_public_path__ + "static/media/17.7df91906.jpeg";